import React from 'react'
import PropTypes from 'prop-types'

import TextField from 'material-ui/TextField'

export default class PinDigitInput extends React.Component {

  static propTypes = {
    id: PropTypes.number.isRequired,
    disabled: PropTypes.bool,
    digit: PropTypes.number.isRequired,
    onDigitChanged: PropTypes.func.isRequired,
    onEnterPressed: PropTypes.func.isRequired
  }

  handleKeyPressed = event => {
    event.preventDefault()
    if (event.key === 'Enter') {
      this.props.onEnterPressed()
    }
    else {
      let value = parseInt(event.key)
      if (!isNaN(value)) {
        this.props.onDigitChanged(value)
      }
    }
  }

  focus = () => {
    if (this.input) {
      this.input.focus()
    }
  }

  render() {
    return (
      <TextField
        id={this.props.id.toString()}
        ref={input => this.input = input}
        style={styles.textField}
        inputStyle={styles.input}
        disabled={this.props.disabled}
        value={this.props.digit}
        floatingLabelFocusStyle={{ color: '#527da3' }}
        underlineFocusStyle={{ borderColor: '#527da3' }}
        onKeyDown={this.handleKeyDown}
        onKeyPress={this.handleKeyPressed} />
    )
  }

}

const styles = {

  input: {
    color: 'rgba(155, 155, 155, 0.5)',
    textAlign: 'center',
    width: 28,
    height: 32,
    fontSize: 36,
    fontWeight: 300,
    fontFamily: 'Roboto'
  },

  textField: {
    width: 30,
    marginLeft: 11,
    marginRight: 11
  }

}


// WEBPACK FOOTER //
// ./src/login/PinDigitInput.js